export function formatCurrencyNPR(amount: number | undefined | null): string {
  const n = amount ?? 0;
  return new Intl.NumberFormat('en-NP', {
    style: 'currency',
    currency: 'NPR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);
}


